import { addStyles } from 'ethcss'
import { colors, grid, IStyles, mediaCSS } from 'theme'

const uploaderStyles: IStyles = {
    wrapper: {
        borderRadius: 20,
        backgroundColor: colors.white,
    },
    wrapperShadow: {
        border: '1px solid #F0F0F0',
        boxShadow: '0px 4px 20px 0px #0000000D',
        marginTop: 54,
        width: 600,
        padding: 24,
    },
    uploadLabel: {
        fontSize: 22,
        fontWeight: 700,
    },
    hint: {
        textAlign: 'center',
    },
    section: {
        borderRadius: 6,
        width: '100%',
        padding: '24px 60px',

        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        alignItems: 'center',
    },
    sampleFileSection: {
        backgroundColor: colors.water,
    },
    fileItem: {
        width: '100%',
        padding: '8px 12px',
        border: `1px solid ${colors.greyLight}`,
        borderRadius: 6,

        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    fileInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
    },
    uploadOptions: {
        ...grid.row,
        gap: 24,
        ...grid.pt_mini,
        [mediaCSS.tabMini]: {
            ...grid.col,
            gap: 16,
        },
    },
    buttons: {
        ...grid.row,
        justifyContent: 'center',
        gap: 10,
        [mediaCSS.tabMini]: {
            justifySelf: 'center',
            ...grid.normalCenter,
        },
    },
    dividerTitle: {
        marginBottom: 5,
    },
    dropdown: {
        marginBottom: 50,
        maxWidth: 250,
    },
}

addStyles(uploaderStyles)
export default uploaderStyles
